import { useEffect, useState } from "react"
import { fetchEditExam, fetchExams } from "../ExamApi"
import { toast } from "react-toastify"
import ExamListCard from "./ExamListCard"
import { useDispatch, useSelector } from "react-redux"
import { selectTranslations } from "../../../services/i18n/i18nSlice"
import { Link } from "react-router-dom"

import open_icon from '../../../assets/images/open.svg'
import exam_icon from '../../../components/Navigation/icons/verifica.svg'
import trash_icon from '../../../assets/images/trash.svg'
import chart_icon from '../../../assets/images/exams/chart.svg'
import { setLoading } from "../../../services/global/globalSlice"
import ConfirmModal from "../../../components/_modals/ConfirmModal"

export default function ExamsList (props) {

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()

    const [examsData, setExamsData] = useState([])
    const [selectedExam, setSelectedExam] = useState(null)
    const [fetchState, setFetchState] = useState(
       { start_cursor: null }
    )
    const [confirmModal, setConfirmModal] = useState({
        title: "",
        text: "",
        onClose: null,
        onConfirm: null,
        confirmCta: "",
        closeCta: ""
    })


    const handleSelectExam = (i) => {
        setSelectedExam(i)
    }

    const loadExams = async (reset = false) =>{
        dispatch(setLoading(true))
        const _params = {
            ...(props?.filter?.limit && {limit: props?.filter?.limit} ),
            ...(props?.filter?.state && {state: props?.filter?.state} ),
            ...(props?.filter?.started !== null && {started: props?.filter?.started} ),
            ...(props?.filter?.ended !== null && {ended: props?.filter?.ended} ),
            ...(fetchState?.start_cursor && {start_cursor: fetchState.start_cursor})
        }
        const response = await fetchExams(_params)
        if(response.success){
            setExamsData(reset ? response?.data?.exams : [...examsData, ...response?.data?.exams])
            setFetchState({start_cursor: response?.data?.next_cursor})
        } else {
            toast.error(t.exams.errors.loading)
        }
         dispatch(setLoading(false))    
    }

    const closeConfirmModal = () =>{
        setConfirmModal({
            ...confirmModal,
            show:false
        })
    }

    const prepareExamData = () => {
        const _data = structuredClone(selectedExam)
        if(_data['start_date'])
            _data['start_date'] = `${new Date(_data['start_date']).toISOString().substring(0,19)}+00:00`
        if(_data['end_date'])
            _data['end_date'] = `${new Date(_data['end_date']).toISOString().substring(0,19)}+00:00`
        else if(_data['end_date'] === "")
            delete _data.end_date
        if(_data['time'])
            _data['time'] = parseInt(_data['time'])
        if(_data['thresholds']?.length > 0)
            _data['thresholds'] = _data['thresholds']?.map((t)=>{
                if(t.threshold_name)
                    return {
                        threshold_name: t.threshold_name,
                        score: parseInt(t.score),
                        threshold_type: t.threshold_type
                    }
        })
        return _data
    }

    const deleteExam = async (_,force) => {
        if(!force){
            setConfirmModal({
                ...confirmModal,
                show:true,
                title: t.exam.delete_title,
                text: t.exam.delete_text,
                onClose: ()=>closeConfirmModal(),
                onConfirm: ()=>deleteExam(true,true),
                confirmCta: t.exam.delete_cta,
                closeCta: t.modals.abort,
            })
        } else {
            dispatch(setLoading(true))
            const _examData = prepareExamData()
            _examData['state'] = 'deleted'
            const response = await fetchEditExam(_examData?.exam_id, _examData)
            if(response.success){
                toast.success(t.exam.deleted_exam)
                dispatch(setLoading(false))
                loadExams(true)
            } else {
                toast.error(t.exam.error_saving_exam)
                dispatch(setLoading(false))
            }
            closeConfirmModal()
        }
    }

    useEffect(()=>{
        loadExams(true)
    },[props.filter])

    return(
        <>
            { selectedExam ?
                <div className="d-flex align-items-center justify-content-end mb-4 exams-step-2">
                    <Link disabled={!selectedExam} style={{opacity: !selectedExam ? '0.5' : 1}} className="ms-3" to={`/exams/user_exams/${selectedExam?.exam_id}`} >
                        <img src={chart_icon} />
                        {t.exams.open_user_exams}
                    </Link>
                    <Link disabled={!selectedExam} style={{opacity: !selectedExam ? '0.5' : 1}}  className="ms-3" to={`/exams/details/${selectedExam?.exam_id}`} >
                        <img src={open_icon} />
                        {t.exams.open_edit}
                    </Link>
                    <a disabled={!selectedExam || selectedExam.state === "deleted"} className="ms-3" style={{opacity: !selectedExam || selectedExam.state === "deleted" ? '0.5' : 1}}  href="#" onClick={deleteExam} >
                        <img src={trash_icon} />
                        <span className="text-danger">{t.exams.delete_exam}</span>
                    </a>
                </div>
                : 
                <div className="mb-4" style={{height:'25px'}}></div>
            }
            <div className="exams_list">
                {examsData?.map((e,i)=>{
                    return <ExamListCard selectedExam={e.exam_id===selectedExam?.exam_id} handleSelectExam={()=>handleSelectExam(e)} key={i} index={i} data={e} />
                })}
            </div>
            {
                !examsData || examsData.length === 0 ?
                    <div className="text-center">
                        <img src={exam_icon} className="mb-2" />
                        <h2>{t.exams.no_exam_available} <strong style={{textTransform:"lowercase"}}>
                            { props.filter?.started && !props.filter?.ended ?
                                t.exams.progress :
                                (
                                    props.filter?.ended ?
                                        t.exams.past :
                                        (props.filter?.state === "ready" ?
                                            t.exams.future :
                                            t.exams[props.filter?.state]
                                        )
                                )
                            }
                        </strong></h2>
                    </div>
                : null
            }
            <ConfirmModal props={confirmModal}/>
        </>
    )
}